﻿import PropTypes from "prop-types";
import React from "react";
import { TextBox, Button } from "wbm-inputs";
import Enums from "../constants/enums";
import { totalCartItems } from "../utilities/utilities";
import CartItemChild from "./cartItemChild";
import CartItemDropdown from "./cartItemDropdown";
import CartItemDropdownListItem from "./cartItemDropdownListItem";
import { NavInkImage } from "./navInkImage";
import { ErrorOutlineSvg, CheckCircleOutline } from "./svgs.js";
import Chip from "@material-ui/core/Chip";
import Tooltip from "@material-ui/core/Tooltip";
import { WBMFormatMoney } from "wbm-format-money";

export default class CartItemsList extends React.Component {
  constructor(props, context) {
    super(props, context);

    this.addRemoveItem = this.addRemoveItem.bind(this);
    this.addRemoveAllItems = this.addRemoveAllItems.bind(this);
    this.splitLine = this.splitLine.bind(this);
    this.onQtyChange = this.onQtyChange.bind(this);
    this.onNoteChange = this.onNoteChange.bind(this);
    this.onApplySplitLine = this.onApplySplitLine.bind(this);
    this.onApplyAllocatedItems = this.onApplyAllocatedItems.bind(this);

    this.state = {
      selectedList: [],
      cartLineRecId: null,
      qty: "",
      qtyIsValid: null,
      note: "",
      removedCartLineRecIds: [],
    };
  }

  componentDidUpdate(prevProps) {
  if (this.props.hasRemoveCartError && !prevProps.hasRemoveCartError) {
    this.setState({ removedCartLineRecIds: [] });
  }
}

  onQtyChange(val) {
    if (val === "" || (!isNaN(val) && +val > 0)) {
      this.setState({
        qty: val,
      });
    }
  }

  onNoteChange(val) {
    this.setState({
      note: val,
    });
  }

  onApplySplitLine(e, existingQuantity) {
    e.preventDefault();
    if (+this.state.qty >= existingQuantity) {
      this.setState({
        qtyIsValid: false,
      });
    } else {
      this.setState({
        qtyIsValid: null,
      });
      this.props.onApplySplitLine(
        this.state.cartLineRecId,
        existingQuantity,
        +this.state.qty,
        this.state.note
      );
    }
  }

  addRemoveItem(id) {
    let list = this.state.selectedList;
    let index = list.indexOf(id);
    if (index !== -1) {
      list.splice(index, 1);
    } else {
      list = [...this.state.selectedList, id];
    }
    this.setState({
      selectedList: list,
    });
  }

  addRemoveAllItems() {
    if (this.state.selectedList.length === this.props.cartItems.length) {
      this.setState({
        selectedList: [],
      });
    } else {
      let selectedList = [];
      for (let cartItem in this.props.cartItems) {
        selectedList.push(this.props.cartItems[cartItem].cartLineRecId);
      }
      this.setState({
        selectedList: selectedList,
      });
    }
  }

  splitLine(e, id) {
    e.preventDefault();
    if (this.state.cartLineRecId === id) {
      this.setState({
        cartLineRecId: null,
        qty: "",
        note: "",
      });
    } else {
      this.setState({
        cartLineRecId: id,
        qty: "",
        note: "",
      });
    }
  }

  onApplyAllocatedItems() {
    this.props.onApplyAllocatedItems(this.state.selectedList);
    this.setState({
      selectedList: [],
    });
  }

  isKitItem(cartItem) {
    return (
      !this.props.lineLevelAllocation &&
      !this.props.allocations &&
      cartItem.kitItemId
    );
  }

  getItemIdentifier(cartItem) {
    return this.isKitItem(cartItem)
      ? {
          id: cartItem.kitItemId,
          unitId: cartItem.kitItemUnitId,
          couponOfferCode: cartItem.itemIdentifier.couponOfferCode,
        }
      : cartItem.itemIdentifier;
  }

  getSelectedLineLevelAllocations() {
    return this.props.allocations.allocations.map((allocation, index) => {
      let displayValue = allocation.code;
      if (allocation.value) {
        displayValue += " - " + allocation.value;
      } else {
        displayValue = allocation.id + " - " + displayValue;
      }
      return (
        <Chip
          key={"selectedAllocation" + index}
          className="wbmcil-selected-allocation"
          label={displayValue}
        />
      );
    });
  }

  getCartItemImage(cartItem, kitImages) {
    const isKitItem = this.isKitItem(cartItem);
    const isNavInkItem = cartItem.proofThumbnailUrl;
    let brandImage = null;

    if (isNavInkItem) {
      return (
        <NavInkImage
          src={cartItem.proofThumbnailUrl}
          altSrc={cartItem.altProofThumbnailUrl}
        />
      );
    }

    if (isKitItem) {
      if (kitImages[cartItem.kitItemId]) {
        brandImage = kitImages[cartItem.kitItemId];
      }
    } else if (cartItem.brandImage != null) {
      brandImage = cartItem.brandImage;
    }

    if (brandImage !== null) {
      return (
        <img
          src={brandImage.imagePath + "/" + brandImage.imageFileName}
          alt="Item"
        />
      );
    }

    // Some consumers of this component do not get the cart data all at once.
    // Do not show "no product image" unless there is a total and description.
    const total = this.getCartItemTotal(cartItem);
    if (total > 0 && cartItem.description) {
      const defaultNoImageUrl = "https://images.wbmason.com/100/nia-100.jpg";

      return (
        <img
          src={
            this.props.noImageUrl ? this.props.noImageUrl : defaultNoImageUrl
          }
          alt="Item"
        />
      );
    } else {
      return <div className="wbmcil-item-image-container-empty"></div>;
    }
  }

  getCartItemTotal(cartItem) {
    let itemTotal = cartItem.qty * cartItem.sellPrice;

    return itemTotal;
  }

  getCartItemDiscountTotal(cartItem) {
    let discountTotal = -1;

    if (
      cartItem.discount &&
      cartItem.discountType === Enums.AmountPercent.Percent &&
      cartItem.discount > 0
    ) {
      discountTotal = this.getCartItemTotal(cartItem) - cartItem.discount;
    }

    return discountTotal;
  }

  renderImageAndDetailsAndPrice(cartItem, kitImages) {
    const isKitItem = this.isKitItem(cartItem);
    const isNavInkItem = cartItem.purchaseProcess === 30;
    const isNavInkItemWithLotQty = isNavInkItem && cartItem.lotQty;

    const itemId = isKitItem ? cartItem.kitItemId : cartItem.itemIdentifier.id;
    const unitId = isKitItem
      ? cartItem.kitItemUnitId
      : cartItem.itemIdentifier.unitId;
    const itemBrand = isKitItem
      ? cartItem.kitItemBrandName
      : cartItem.brandName;
    const itemDescription = isKitItem
      ? cartItem.kitItemDescription
      : cartItem.description;
    const cartItemImage = this.getCartItemImage(cartItem, kitImages);
    const productDetailsUrl = isKitItem && cartItem.productDetailsUrl
      ? cartItem.productDetailsUrl
        .replace(new RegExp(cartItem.itemIdentifier.id, 'g'), cartItem.kitItemId)
        .replace(new RegExp(cartItem.itemIdentifier.unitId, 'g'), cartItem.kitItemUnitId)
      : cartItem.productDetailsUrl;

    let qty = isKitItem ? cartItem.kitItemQty : cartItem.qty;
    let itemTotal = this.getCartItemTotal(cartItem);
    let discountTotal = this.getCartItemDiscountTotal(cartItem);
    let sellPrice = cartItem.lineAmount / qty;

    if (isKitItem) {
      const kitItems = this.getKitItems(cartItem);

      itemTotal = 0;
      discountTotal = 0;

      kitItems.forEach((kitItem) => {
        let total = this.getCartItemTotal(kitItem);
        let discount = this.getCartItemDiscountTotal(kitItem);

        itemTotal += total;

        if (discount >= 0) {
          discountTotal += discount;
        } else {
          discountTotal += total;
        }
      });

      if (discountTotal === itemTotal) {
        discountTotal = -1;
      }

      sellPrice = itemTotal / qty;
    } else if (isNavInkItemWithLotQty) {
      qty = qty * cartItem.lotQty;
    }

    const itemTotalClass =
      discountTotal >= 0 ? "wbmcil-cross-out" : "font-weight-bold";

    return (
      <>
            <a href={productDetailsUrl} aria-label="Product details">
          <div className="wbmcil-item-image-container">{cartItemImage}</div>
       </a>
        <div className="wbmcil-item-details-container">
          <a href={productDetailsUrl} aria-label="Product details">
            <div className="font-weight-bold">
              {itemBrand} {itemDescription}
            </div>
          </a>
          <div className="wbmcil-text-gray">
            {itemId}
            {cartItem.itemIdentifier.couponOfferCode}
          </div>
          <div className="wbmcil-text-gray">QTY: {qty}</div>
          {this.renderItemIndicatorSection(cartItem)}
        </div>
        <div className="wbmcil-item-pricing-container">
          {discountTotal >= 0 ? (
            <div className="font-weight-bold wbmcil-text-red">
                <WBMFormatMoney amount={discountTotal} useCurrencySign />
            </div>
          ) : null}
          <div className={itemTotalClass}>
            <WBMFormatMoney amount={itemTotal} useCurrencySign />
          </div>
          {!isNavInkItemWithLotQty && (
            <div className="wbmcil-text-gray">
                <WBMFormatMoney amount={sellPrice} useCurrencySign /> / {unitId}
            </div>
          )}
          {this.renderEditAndRemove(cartItem)}
        </div>
      </>
    );
  }

  renderAllSalesFinal(cartItem) {
    return (
      <>
        {cartItem.webNonReturnable && this.props.allSalesFinalText && (
          <div className="row no-gutters">
            <div className="col">
              <span className="font-weight-bold wbmcil-text-red">
                {this.props.allSalesFinalText}
              </span>
            </div>
          </div>
        )}
      </>
    );
  }

  renderNavInkLotQtyMessage(cartItem) {
    const isNavInkItem = cartItem.purchaseProcess === 30;
    const isNavInkItemWithLotQty = isNavInkItem && cartItem.lotQty > 0;

    return (
      <>
        {isNavInkItemWithLotQty && this.props.showNavInkLotQtyMessage && (
          <div className="row no-gutters wbmcil-navink-message">
            <div className="col">
              <span className="wbmcil-grey-text">
                Your order will be processed for {cartItem.qty}{" "}
                {cartItem.qty > 1 ? "lots" : "lot"} of {cartItem.lotQty} at $
                <WBMFormatMoney amount={cartItem.sellPrice} />/{cartItem.itemIdentifier.unitId}
              </span>
            </div>
          </div>
        )}
      </>
    );
  }

  renderLineComment(cartItem) {
    return (
      <>
        {cartItem.lineComment && !cartItem.kitItemId && (
          <div className="row no-gutters wbmcil-split-line-comment">
            <div className="col">
              <span className="wbmcil-grey-text">
                Note: {cartItem.lineComment}
              </span>
            </div>
          </div>
        )}
      </>
    );
  }

  renderAddOnItemMessage(cartItem) {
    return (
      <>
        {cartItem.addOnItem && cartItem.addOnUserMessage && (
          <div className="row no-gutters">
            <div className="col">
              <span className="wbmcil-addon-message">
                {cartItem.addOnUserMessage}
              </span>
            </div>
          </div>
        )}
      </>
    );
  }

  getKitItems(cartItem) {
    const childrenItems = this.props.cartItems.filter(
      (childItem) =>
        childItem.kitItemId === cartItem.kitItemId &&
        childItem.itemIdentifier.couponOfferCode ===
          cartItem.itemIdentifier.couponOfferCode
    );

    return childrenItems;
  }

  renderKitItem(cartItem) {
    const childrenItems = this.getKitItems(cartItem);
    return (
      <CartItemDropdown
        alwaysFullWidth={true}
        buttonContent={
          <span className="kit-item-txt">
            {cartItem.kitItemId} will appear as the following items on your
            packing slip and invoice.
          </span>
        }
      >
        {this.mapChildCartItems(childrenItems)}
      </CartItemDropdown>
    );
  }

  renderChildItems(childrenItems, label = "Additional Charges") {
    let childItemTotal = 0;

    childrenItems.forEach((childItem) => {
      let total = this.getCartItemTotal(childItem);
      let discount = this.getCartItemDiscountTotal(childItem);

      if (discount >= 0) {
        childItemTotal += discount;
      } else {
        childItemTotal += total;
      }
    });

    return (
      <CartItemDropdown
        chevronLeft
        alwaysFullWidth={this.props.useMobile}
        displayVerticalLine={false}
        buttonContent={
          <>
            <span className="additional-charges-label">{label}</span>
            <b className="additional-charges-total float-right">
              {childItemTotal >= 0 ? "+" : "-"} $
              <WBMFormatMoney amount={Math.abs(childItemTotal)} />
            </b>
          </>
        }
      >
        {this.mapChildCartItems(childrenItems)}
      </CartItemDropdown>
    );
  }

  mapChildCartItems(childrenItems) {
    return (
      <>
        {childrenItems.map((childItem, index) => {
          const key = `cart.${childItem.cartLineRecId}.${index}`;
          const itemTotal = this.getCartItemTotal(childItem);
          const discountTotal = this.getCartItemDiscountTotal(childItem);

          return (
            <CartItemDropdownListItem key={key}>
              <CartItemChild
                cartItem={childItem}
                itemTotal={itemTotal}
                discountTotal={discountTotal}
                useMobile={this.props.useMobile}
              />
            </CartItemDropdownListItem>
          );
        })}
      </>
    );
  }

  renderChildLines(cartItem) {
    if (cartItem.kitItemId) {
      return this.renderKitItem(cartItem);
    }

    const childrenItems = this.props.cartItems.filter(
      (potentialChild) =>
        potentialChild.parentLineRecId === cartItem.cartLineRecId
    );

    if (childrenItems.length !== 0) {
      return cartItem.purchaseProcess === 30
        ? this.renderChildItems(childrenItems, "View Pricing Details")
        : this.renderChildItems(childrenItems);
    }

    return <></>;
  }

  renderRegularCartItem(cartItem, key, kitImages, index) {
    return (
      <div className="wbmcil-cart-item" key={key}>
        <div
          className={
            "row no-gutters wbmcil-item " +
            (index == 0 && !this.props.allocations
              ? "no-border-with-padding"
              : "")
          }
        >
          <div className="col">
            {this.renderImageAndDetailsAndPrice(cartItem, kitImages)}
          </div>
        </div>
        <div className="row">
          <div className="col">
            {this.renderProductAvailabilitySection(cartItem)}
          </div>
        </div>
        {this.renderAllSalesFinal(cartItem)}
        {this.renderNavInkLotQtyMessage(cartItem)}
        {this.renderLineComment(cartItem)}
        {this.renderAddOnItemMessage(cartItem)}
        {!this.props.allocations && this.renderChildLines(cartItem)}
      </div>
    );
  }

  renderLineLevelAllocation(cartItem, key, kitImages) {
    return (
      <div className="wbmcil-cart-item" key={key}>
        <div className="row wbmcil-item">
          <div className="col-10 px-0 px-md-3">
            {this.renderImageAndDetailsAndPrice(cartItem, kitImages)}
          </div>
          <div className="col-2 pr-0 pr-md-3 wbmcil-line-level-container">
            <div className="wbmcil-line-level">
              {this.props.lineLevelSelection && !this.props.allocations && (
                <div
                  className={
                    this.state.selectedList.includes(cartItem.cartLineRecId)
                      ? "wbmcil-add-circle wbmcil-selected"
                      : "wbmcil-add-circle"
                  }
                  onClick={() => this.addRemoveItem(cartItem.cartLineRecId)}
                >
                  <CheckCircleOutline />
                </div>
              )}
              {this.props.lineLevelSelection && this.props.allocations && (
                <div
                  className={
                    this.state.selectedList.includes(cartItem.cartLineRecId)
                      ? "wbmcil-remove-circle wbmcil-selected"
                      : "wbmcil-remove-circle"
                  }
                  onClick={() => this.addRemoveItem(cartItem.cartLineRecId)}
                >
                  <CheckCircleOutline />
                </div>
              )}
              {
                //Purchase Process of 30 is navInk
                !this.props.allocations &&
                cartItem.qty > 1 &&
                cartItem.purchaseProcess !== 30 &&
                !cartItem.kitItemId ? (
                  <div className="wbmcil-split-line">
                    <a
                      href="#"
                      onClick={() =>
                        this.splitLine(event, cartItem.cartLineRecId)
                      }
                    >
                      Split Line
                    </a>
                  </div>
                ) : null
              }
            </div>
          </div>
        </div>
        {this.renderAllSalesFinal(cartItem)}
        {this.renderNavInkLotQtyMessage(cartItem)}
        {this.renderLineComment(cartItem)}
        {this.renderAddOnItemMessage(cartItem)}
        {this.state.cartLineRecId === cartItem.cartLineRecId ? (
          <div className="row no-gutters wbmcil-split-line">
            <div className="col-2">
              <TextBox
                id={"splitLineQty" + cartItem.cartLineRecId}
                label="QTY"
                isValid={this.state.qtyIsValid}
                value={this.state.qty}
                invalidFeedback={"Valid Quantity is required!"}
                onChange={this.onQtyChange}
              />
            </div>
            <div className="col-6 col-md-5">
              <TextBox
                id={"splitLineNote" + cartItem.cartLineRecId}
                label="Note"
                isValid={null}
                value={this.state.note}
                invalidFeedback={"Note is required!"}
                onChange={this.onNoteChange}
                maxLength={255}
              />
            </div>
            <div className="col-3">
              <button
                type="button"
                className="btn btn-primary"
                disabled={!this.state.qty || this.state.qty <= 0}
                onClick={() => this.onApplySplitLine(event, cartItem.qty)}
              >
                Apply
              </button>
            </div>
            <div className="wbmcil-notification">
              <ErrorOutlineSvg />
              <span className="wbmcil-grey-text">
                The quantity you enter will be deducted from the top line.
              </span>
            </div>
          </div>
        ) : null}
      </div>
    );
  }

  renderCartItemList() {
    const kitItemIds = [];
    // cartItem.kitImage is only set on one of the kit item cart lines and needs to be shared
    const kitImages = {};

    return (
      <>
        {this.props.cartItems &&
          this.props.cartItems
            .filter((cartItem) => {
              // do not display child lines if the parent is present (allocations can separate them)
              if (
                  !this.props.lineLevelAllocation &&
                  !this.props.allocations &&                  
                  cartItem.parentLineRecId &&
                  (this.props.cartItems.some(x => x.cartLineRecId === cartItem.parentLineRecId))
              ) {
                return false;
              }

              // only display a kit item once
              if (
                !this.props.lineLevelAllocation &&
                !this.props.allocations &&
                cartItem.kitItemId
              ) {
                if (cartItem.kitImage) {
                  kitImages[cartItem.kitItemId] = cartItem.kitImage;
                }

                if (
                  kitItemIds.indexOf(
                    cartItem.kitItemId + cartItem.itemIdentifier.couponOfferCode
                  ) === -1
                ) {
                  kitItemIds.push(
                    cartItem.kitItemId + cartItem.itemIdentifier.couponOfferCode
                  );

                  return true;
                }

                return false;
              }

              return true;
            })
            // limit max number of items to display
            .filter((_, index) => {
              if (
                typeof this.props.maxItemsToDisplay === "number" &&
                this.props.maxItemsToDisplay >= 0
              ) {
                if (index >= this.props.maxItemsToDisplay) {
                  return false;
                }
              }

              return true;
            })
            .map((cartItem, index) => {
              const key = `cart.${cartItem.cartLineRecId}.${index}`;

              if (this.props.lineLevelAllocation) {
                return this.renderLineLevelAllocation(cartItem, key, kitImages);
              } else {
                return this.renderRegularCartItem(
                  cartItem,
                  key,
                  kitImages,
                  index
                );
              }
            })}
      </>
    );
  }

  renderItemIndicatorSection(cartItem) {
    const itemIdentifier = this.getItemIdentifier(cartItem);

    return this.props.itemIndicators !== undefined &&
      this.props.itemIndicators &&
      this.props.itemIndicators.length ? (
      <div className="wbmcil-item-indicators">
        {this.props.itemIndicators
          .filter(
            (icon) =>
              icon.itemIdentifier.id === itemIdentifier.id &&
              icon.itemIdentifier.unitId === itemIdentifier.unitId
          )
          .map((indicatorIcon, index) => {
            return (
              <img
                src={indicatorIcon.iconUrl}
                alt={indicatorIcon.iconAltText}
                title={indicatorIcon.iconAltText}
                height={15}
                width={
                  (indicatorIcon.iconWidth / indicatorIcon.iconHeight) * 15
                }
                className="wbmcil-item-indicator"
                key={cartItem.cartLineRecId + " indicator: " + index}
              />
            );
          })}
      </div>
    ) : null;
  }

  renderProductAvailabilitySection(cartItem) {
    const itemIdentifier = this.getItemIdentifier(cartItem);
    const ecomUrl = this.props.ecomUrl || "https://www.wbmason.com/";
    const availabilityPopupPageUrl = `${ecomUrl}PopupPage.aspx?cpi=Availability`;

    return this.props.availabilityInfo &&
      this.props.availabilityInfo &&
      this.props.availabilityInfo.length
      ? this.props.availabilityInfo
          .filter(
            (product) =>
              product.itemId === itemIdentifier.id &&
              product.unitId === itemIdentifier.unitId
          )
          .map((productAvailability, index) => {
            return (
              <div
                className={
                  "wbmcil-product-availability-" +
                  Enums.AlertLevelMap[productAvailability.alertLevel]
                }
                key={cartItem.cartLineRecId + " availability"}
              >
                {productAvailability.doPreventAddToCart ? (
                  <>
                    <div className="font-weight-bold text-danger">
                      {productAvailability.preventPurchaseMessage}
                    </div>
                    <div className="text-danger">
                      Please Remove Item From Cart.
                    </div>
                  </>
                ) : (
                  <>
                    {productAvailability.calloutMessage && (
                      <div>{productAvailability.calloutMessage}</div>
                    )}
                    {productAvailability.wbTruckDelivery && (
                      <img
                        alt="truck"
                        src={"https://images.wbmason.com/65/wb_truck.png"}
                      />
                    )}
                    {productAvailability.requiresMessageDescriptions ? (
                      <a
                        href={availabilityPopupPageUrl}
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        <span>{productAvailability.deliveryMessage}</span>
                      </a>
                    ) : (
                      <span>{productAvailability.deliveryMessage}</span>
                    )}
                  </>
                )}
              </div>
            );
          })
      : null;
  }

  renderEmptyCart() {
    return (
      <div className="wbmcil-cart-items-container">
        {(this.props.title || this.props.editCartUrl) && (
          <div className="row wbmcil-cart-items-header">
            <div className="col-6">
              <h5>{this.props.title}</h5>
            </div>
            <div className="col-6 text-right">
              <a href={this.props.editCartUrl}>Edit Cart (0)</a>
            </div>
          </div>
        )}
        <div className="row wbmcil-empty-cart-container">
          <div className="col wbmcil-empty-cart-content">
            {<h5>Your shopping cart is empty.</h5>}
            {this.props.ecomHomePageURL ? (
              <a
                href={this.props.ecomHomePageURL}
                onClick={this.props.closeComponent}
              >
                Continue Shopping
              </a>
            ) : (
              <span onClick={this.props.closeComponent}>Continue Shopping</span>
            )}
          </div>
        </div>
      </div>
    );
  }

  renderEditAndRemove(cartItem) {
    return (
      <>
        {this.props.shoppingCartUrl && (
          <div>
            <a className="wbmcil-action-link" href={this.props.shoppingCartUrl}>
              Edit
            </a>
          </div>
        )}
        {this.props.removeItemCallback && !cartItem.addOnItem && (
          <div>
            {this.state.removedCartLineRecIds.includes(
              cartItem.cartLineRecId
            ) ? (
              <span
                className="spinner spinner-border"
                role="status"
                aria-hidden="true"
              />
            ) : (
              <button
                className="wbmcil-action-link"
                onClick={() => {
                  if (
                    this.state.removedCartLineRecId === cartItem.cartLineRecId
                  ) {
                    return;
                  } else {
                    this.setState({
                      removedCartLineRecIds: [
                        ...this.state.removedCartLineRecIds,
                        cartItem.cartLineRecId,
                      ],
                    });

                    this.props.removeItemCallback(cartItem);
                  }
                }}
              >
                Remove
              </button>
            )}
          </div>
        )}
      </>
    );
  }

  render() {
    let displayApplyRemove = null;
    if (this.props.lineLevelSelection && this.state.selectedList.length) {
      if (this.props.allocations) {
        displayApplyRemove = false;
      } else {
        displayApplyRemove = true;
      }
    }

    let cartItemCount = totalCartItems(this.props.cartItems);

    if (cartItemCount === 0) {
      return this.renderEmptyCart();
    }

    if (!this.props.cartItems || !this.props.cartItems.length) {
      return null;
    }

    return (
      <div className="wbmcil-cart-items-container">
        <div className="row wbmcil-cart-items-header">
          <div
            className={
              this.props.lineLevelSelection || !this.props.editCartUrl
                ? "col-10"
                : "col-6 col-md-6"
            }
          >
            {this.props.title ? (
              <h5>{this.props.title}</h5>
            ) : (
              <div className="title-header"></div>
            )}
            {displayApplyRemove === null ? null : displayApplyRemove ===
              true ? (
              <Button
                type="button"
                className="btn btn-success small"
                onClick={this.onApplyAllocatedItems}
              >
                APPLY
              </Button>
            ) : null}
          </div>
          {this.props.editCartUrl &&
            !(
              this.props.lineLevelSelection || this.props.lineLevelAllocation
            ) && (
              <div className="col-6 text-right">
                <a href={this.props.editCartUrl}>Edit Cart ({cartItemCount})</a>
              </div>
            )}
          {this.props.lineLevelSelection && !this.props.allocations && (
            <div className="col-2 px-0 px-md-3 text-right">
              <Tooltip arrow placement="top" title="Select All">
                <div
                  className={
                    this.state.selectedList.length ===
                    this.props.cartItems.length
                      ? "wbmcil-selected wbmcil-add-circle"
                      : "wbmcil-add-circle"
                  }
                  onClick={this.addRemoveAllItems}
                >
                  <CheckCircleOutline />
                </div>
              </Tooltip>
            </div>
          )}
        </div>
        {this.props.allocations && (
          <div className={"wbmcil-allocations-container"}>
            <div className="row no-gutters">
              <div className="col">
                {this.getSelectedLineLevelAllocations()}
              </div>
              <div className="col-auto d-flex align-items-center">
                {this.props.lineLevelSelection && this.props.allocations && (
                  <div className="px-0 px-md-3 d-none d-md-flex text-right">
                    <Tooltip arrow placement="top" title="Select All">
                      <div
                        className={
                          this.state.selectedList.length ===
                          this.props.cartItems.length
                            ? "wbmcil-selected wbmcil-remove-circle"
                            : "wbmcil-remove-circle"
                        }
                        onClick={this.addRemoveAllItems}
                      >
                        <CheckCircleOutline />
                      </div>
                    </Tooltip>
                  </div>
                )}
              </div>
            </div>
          </div>
        )}
        {this.props.cartItems && this.renderCartItemList()}
        {displayApplyRemove === null ? null : displayApplyRemove === true ? (
          <Button
            className="btn-success w-100"
            onClick={this.onApplyAllocatedItems}
          >
            APPLY
          </Button>
        ) : (
          <Button
            className="btn-danger w-100"
            onClick={this.onApplyAllocatedItems}
          >
            REMOVE
          </Button>
        )}
      </div>
    );
  }
}

CartItemsList.propTypes = {
  allocations: PropTypes.object,
  cartItems: PropTypes.arrayOf(PropTypes.object),
  editCartUrl: PropTypes.string,
  lineLevelAllocation: PropTypes.bool,
  lineLevelSelection: PropTypes.bool,
  onApplyAllocatedItems: PropTypes.func,
  onApplySplitLine: PropTypes.func,
  title: PropTypes.string,
  noImageUrl: PropTypes.string,
  maxItemsToDisplay: PropTypes.number,
  closeComponent: PropTypes.func,
  ecomUrl: PropTypes.string,
};
